import { createSelector } from 'reselect'
import { IRootReducer } from '../../types/reducerTypes'

const accessReducer = (state: IRootReducer) => state.listPool

export const selectAllListPools = createSelector(
  accessReducer,
  (reducer) => reducer.all,
)

export const selectAllPoolsLoading = createSelector(
  accessReducer,
  (reducer) => reducer.all.loading,
)

export const selectListPools = createSelector(
  accessReducer,
  (reducer) => reducer.labs,
)

export const selectUpcomingPools = createSelector(
  accessReducer,
  (reducer) => reducer.labs.upcoming,
)

export const selectActivePools = createSelector(
  accessReducer,
  (reducer) => reducer.labs.active,
)

export const selectCompletedPools = createSelector(
  accessReducer,
  (reducer) => reducer.labs.completed,
)

export const selectOldPoolsAddress = createSelector(
  accessReducer,
  (reducer) => reducer.labs.oldPoolsAddress,
)

export const selectSerialisedPools = createSelector(
  accessReducer,
  (reducer) => reducer.labs.serialisedPools,
)

export const selectLaunchListPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch,
)

export const selectLaunchUpcomingPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.upcoming,
)

export const selectLaunchActivePools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.active,
)

export const selectLaunchCompletedPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.completed,
)

export const selectLaunchMostTractionPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.mostTraction,
)

export const selectLaunchRecentlyLaunchedPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.recentlyLaunched,
)

export const selectLaunchClosingSoonPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.closingSoon,
)

export const selectLaunchMostFundedPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.mostFunded,
)

export const selectLaunchOldPoolsAddress = createSelector(
  accessReducer,
  (reducer) => reducer.launch.oldPoolsAddress,
)

export const selectLaunchSerialisedPools = createSelector(
  accessReducer,
  (reducer) => reducer.launch.serialisedPools,
)
